let MessageHandler = require('./MessageHandler');

class Api {

  static ajax(method, url, data, successCb, errorCb, completeCb, spinner = false) {
    if (spinner) {
      Spinner.displaySpinner();
    }

    let options = {
      url: url,
      method: method,
      data: data,
      success: (response) => {
        Api.handleResponse(response);
        if (successCb) {
          successCb(response);
        }
      },
      error: (requestObject, error, errorThrown) => {
        if (requestObject.status == 401) {
          toastr.warning("Vous n'etes plus connecté. Veuillez rafraichir la page pour vous authentifier");
        } else if (requestObject.status == 403) {
          toastr.warning("Vous n'etes pas autorisé à éffectuer cette action");
        } else {
          toastr.error('Internal server error');
          if (errorCb) {
            errorCb(requestObject, error, errorThrown);
          }
        }
      },
      complete: () => {
        if (completeCb) {
          completeCb();
        }

        if (spinner) {
          Spinner.hideSpinner();
        }
      }
    };

    if (data instanceof FormData) {
      options['contentType'] = false;
      options['processData'] = false;
    }

    return $.ajax(options);
  }

  static GET(url, data, successCb, errorCb, completeCb, spinner = false) {
    return Api.ajax('GET', url, data, successCb, errorCb, completeCb, spinner);
  }

  static POST(url, data, successCb, errorCb, completeCb, spinner = false) {
    return Api.ajax('POST', url, data, successCb, errorCb, completeCb, spinner);
  };

  static handleResponse(response) {
    if (Array.isArray(response)) {
      for (const message of response) {
        MessageHandler.handle(message);
      }
    } else {
      console.error('Api : invalid response, response must be an array.');
      // console.error(response);
    }
  };
}

module.exports = Api;